export class GlobalVariables{

	public static maxSmartPhoneWidth:number  = 500;
}